export default from './Icon';



// WEBPACK FOOTER //
// ./~/buildo-react-components/src/Icon/index.js